import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { QuestionReleases, QuestionType } from '@module/form';

var getQuestionItemKey = function getQuestionItemKey(questionId, childId) {
  return childId ? "".concat(questionId, ":").concat(childId) : questionId;
};

var getQuestionItems = function getQuestionItems(questions, sectionId, answeredQuestionIds, continuousQuestionIndexes) {
  var sectionQuestions = questions.filter(function (question) {
    return question.sectionId === sectionId;
  }).slice().sort(function (firstQuestion, secondQuestion) {
    var _ref, _continuousQuestionIn, _ref2, _continuousQuestionIn2;

    return ((_ref = (_continuousQuestionIn = continuousQuestionIndexes.get(firstQuestion.id.toString())) !== null && _continuousQuestionIn !== void 0 ? _continuousQuestionIn : firstQuestion.index) !== null && _ref !== void 0 ? _ref : 0) - ((_ref2 = (_continuousQuestionIn2 = continuousQuestionIndexes.get(secondQuestion.id.toString())) !== null && _continuousQuestionIn2 !== void 0 ? _continuousQuestionIn2 : secondQuestion.index) !== null && _ref2 !== void 0 ? _ref2 : 0);
  });
  return sectionQuestions.flatMap(function (question) {
    var _ref3, _continuousQuestionIn3;

    var questionId = question.id.toString();
    var displayIndex = (_ref3 = (_continuousQuestionIn3 = continuousQuestionIndexes.get(questionId)) !== null && _continuousQuestionIn3 !== void 0 ? _continuousQuestionIn3 : question.index) !== null && _ref3 !== void 0 ? _ref3 : 1;

    if (question.type === QuestionType.FillInBlank) {
      return question.answers.map(function (answer, answerIndex) {
        return {
          key: getQuestionItemKey(questionId, answer.id.toString()),
          questionId: questionId,
          sectionId: sectionId,
          displayIndex: displayIndex + answerIndex,
          isAnswered: answeredQuestionIds === null || answeredQuestionIds === void 0 ? void 0 : answeredQuestionIds.some(function (answeredQuestionKey) {
            var _answeredQuestionKey$ = answeredQuestionKey.split('_'),
                _answeredQuestionKey$2 = _slicedToArray(_answeredQuestionKey$, 3),
                answerBlankId = _answeredQuestionKey$2[0],
                answeredQuestionId = _answeredQuestionKey$2[1],
                answeredSectionId = _answeredQuestionKey$2[2];

            return answeredSectionId === sectionId && answeredQuestionId === questionId && answerBlankId === answer.id.toString();
          })
        };
      });
    }

    if (question.type === QuestionType.Matching) {
      return question.subQuestions.map(function (subQuestion, subQuestionIndex) {
        return {
          key: getQuestionItemKey(questionId, subQuestion.id.toString()),
          questionId: questionId,
          sectionId: sectionId,
          displayIndex: displayIndex + subQuestionIndex,
          isAnswered: answeredQuestionIds === null || answeredQuestionIds === void 0 ? void 0 : answeredQuestionIds.some(function (answeredQuestionKey) {
            var _answeredQuestionKey$3 = answeredQuestionKey.split('_'),
                _answeredQuestionKey$4 = _slicedToArray(_answeredQuestionKey$3, 3),
                answeredSubQuestionId = _answeredQuestionKey$4[0],
                answeredQuestionId = _answeredQuestionKey$4[1],
                answeredSectionId = _answeredQuestionKey$4[2];

            return answeredSectionId === sectionId && answeredQuestionId === questionId && answeredSubQuestionId === subQuestion.id.toString();
          })
        };
      });
    }

    return [{
      key: getQuestionItemKey(questionId),
      questionId: questionId,
      sectionId: sectionId,
      displayIndex: displayIndex,
      isAnswered: answeredQuestionIds === null || answeredQuestionIds === void 0 ? void 0 : answeredQuestionIds.some(function (answeredQuestionKey) {
        var _answeredQuestionKey$5 = answeredQuestionKey.split('_'),
            _answeredQuestionKey$6 = _slicedToArray(_answeredQuestionKey$5, 3),
            answeredQuestionId = _answeredQuestionKey$6[1],
            answeredSectionId = _answeredQuestionKey$6[2];

        return answeredSectionId === sectionId && answeredQuestionId === questionId;
      })
    }];
  });
};

var getAnsweredCount = function getAnsweredCount(sectionId, answeredQuestionIds) {
  var _answeredQuestionIds$;

  return (_answeredQuestionIds$ = answeredQuestionIds === null || answeredQuestionIds === void 0 ? void 0 : answeredQuestionIds.filter(function (answeredQuestionId) {
    return answeredQuestionId.split('_')[2] === sectionId;
  }).length) !== null && _answeredQuestionIds$ !== void 0 ? _answeredQuestionIds$ : 0;
};

export var useSubmissionSectionSummaryV3 = function useSubmissionSectionSummaryV3(_ref4) {
  var _sectionItems$selecte;

  var sectionSummaries = _ref4.sectionSummaries,
      questionReleases = _ref4.questionReleases,
      answeredQuestionIds = _ref4.answeredQuestionIds,
      readonly = _ref4.readonly,
      selectedSectionIndex = _ref4.selectedSectionIndex,
      currentPlayingAudioId = _ref4.currentPlayingAudioId,
      _ref4$hasCollapseEffe = _ref4.hasCollapseEffect,
      hasCollapseEffect = _ref4$hasCollapseEffe === void 0 ? true : _ref4$hasCollapseEffe,
      _ref4$shouldAutoSelec = _ref4.shouldAutoSelectFirstQuestion,
      shouldAutoSelectFirstQuestion = _ref4$shouldAutoSelec === void 0 ? true : _ref4$shouldAutoSelec,
      label = _ref4.label,
      onSelectQuestion = _ref4.onSelectQuestion;

  var _useState = useState(selectedSectionIndex),
      activeSectionIndex = _useState[0],
      setActiveSectionIndex = _useState[1];

  var _useState2 = useState(),
      selectedQuestion = _useState2[0],
      setSelectedQuestion = _useState2[1];

  var _useState3 = useState(function () {
    return new Set();
  }),
      collapsedSectionIds = _useState3[0],
      setCollapsedSectionIds = _useState3[1];

  var pendingQuestionSelectionRef = useRef();
  var continuousQuestionIndexes = useMemo(function () {
    return QuestionReleases.getContinuousQuestionIndexesInDisplayOrder(questionReleases, sectionSummaries);
  }, [questionReleases, sectionSummaries]);
  var sectionItems = useMemo(function () {
    return sectionSummaries.map(function (section, index) {
      var _section$audioFile;

      var sectionId = section.id.toString();
      var questionItems = getQuestionItems(questionReleases, sectionId, answeredQuestionIds, continuousQuestionIndexes);
      return {
        id: sectionId,
        index: index,
        title: section.title || "".concat(label.section, " ").concat(index + 1),
        answeredCount: readonly ? 0 : getAnsweredCount(sectionId, answeredQuestionIds),
        totalQuestions: questionItems.length,
        questionItems: questionItems,
        isExpanded: !hasCollapseEffect || !collapsedSectionIds.has(sectionId),
        isActive: activeSectionIndex === index,
        isAudioPlaying: Boolean(currentPlayingAudioId && currentPlayingAudioId === ((_section$audioFile = section.audioFile) === null || _section$audioFile === void 0 ? void 0 : _section$audioFile.id.toString()))
      };
    });
  }, [activeSectionIndex, answeredQuestionIds, collapsedSectionIds, continuousQuestionIndexes, currentPlayingAudioId, hasCollapseEffect, label.section, questionReleases, readonly, sectionSummaries]);
  var selectedSectionFirstQuestion = (_sectionItems$selecte = sectionItems[selectedSectionIndex]) === null || _sectionItems$selecte === void 0 ? void 0 : _sectionItems$selecte.questionItems[0];
  useEffect(function () {
    var _pendingQuestionSelec;

    setActiveSectionIndex(selectedSectionIndex);

    if (((_pendingQuestionSelec = pendingQuestionSelectionRef.current) === null || _pendingQuestionSelec === void 0 ? void 0 : _pendingQuestionSelec.sectionIndex) === selectedSectionIndex) {
      setSelectedQuestion(pendingQuestionSelectionRef.current.selection);
      pendingQuestionSelectionRef.current = undefined;
      return;
    }

    pendingQuestionSelectionRef.current = undefined;
    setSelectedQuestion(shouldAutoSelectFirstQuestion && selectedSectionFirstQuestion ? {
      questionKey: selectedSectionFirstQuestion.key,
      wasAnsweredWhenSelected: selectedSectionFirstQuestion.isAnswered
    } : undefined);
  }, [selectedSectionFirstQuestion === null || selectedSectionFirstQuestion === void 0 ? void 0 : selectedSectionFirstQuestion.key, selectedSectionIndex, shouldAutoSelectFirstQuestion]);
  useEffect(function () {
    var _sectionSummaries$sel;

    if (!hasCollapseEffect) {
      return;
    }

    var selectedSectionId = sectionSummaries === null || sectionSummaries === void 0 ? void 0 : (_sectionSummaries$sel = sectionSummaries[selectedSectionIndex]) === null || _sectionSummaries$sel === void 0 ? void 0 : _sectionSummaries$sel.id.toString();

    if (!selectedSectionId) {
      return;
    }

    setCollapsedSectionIds(function (currentCollapsedSectionIds) {
      if (!currentCollapsedSectionIds.has(selectedSectionId)) {
        return currentCollapsedSectionIds;
      }

      var nextCollapsedSectionIds = new Set(currentCollapsedSectionIds);
      nextCollapsedSectionIds["delete"](selectedSectionId);
      return nextCollapsedSectionIds;
    });
  }, [hasCollapseEffect, sectionSummaries, selectedSectionIndex]);
  var toggleSection = useCallback(function (sectionId) {
    if (!hasCollapseEffect) {
      return;
    }

    setCollapsedSectionIds(function (currentCollapsedSectionIds) {
      var nextCollapsedSectionIds = new Set(currentCollapsedSectionIds);

      if (nextCollapsedSectionIds.has(sectionId)) {
        nextCollapsedSectionIds["delete"](sectionId);
      } else {
        nextCollapsedSectionIds.add(sectionId);
      }

      return nextCollapsedSectionIds;
    });
  }, [hasCollapseEffect]);
  var selectQuestion = useCallback(function (sectionIndex, questionItem) {
    var selection = {
      questionKey: questionItem.key,
      wasAnsweredWhenSelected: questionItem.isAnswered
    };

    if (sectionIndex === activeSectionIndex) {
      setSelectedQuestion(selection);
    } else {
      pendingQuestionSelectionRef.current = {
        sectionIndex: sectionIndex,
        selection: selection
      };
    }

    onSelectQuestion === null || onSelectQuestion === void 0 ? void 0 : onSelectQuestion(sectionIndex, questionItem.questionId, questionItem.sectionId);
  }, [activeSectionIndex, onSelectQuestion]);
  var selectedSectionItems = useMemo(function () {
    return sectionItems.map(function (sectionItem) {
      return _objectSpread(_objectSpread({}, sectionItem), {}, {
        questionItems: sectionItem.questionItems.map(function (questionItem) {
          return _objectSpread(_objectSpread({}, questionItem), {}, {
            isSelected: sectionItem.isActive && questionItem.key === (selectedQuestion === null || selectedQuestion === void 0 ? void 0 : selectedQuestion.questionKey) && (selectedQuestion.wasAnsweredWhenSelected || !questionItem.isAnswered)
          });
        })
      });
    });
  }, [sectionItems, selectedQuestion]);
  var totalAnswered = useMemo(function () {
    return selectedSectionItems.reduce(function (total, sectionItem) {
      return total + sectionItem.answeredCount;
    }, 0);
  }, [selectedSectionItems]);
  var totalQuestions = useMemo(function () {
    return selectedSectionItems.reduce(function (total, sectionItem) {
      return total + sectionItem.totalQuestions;
    }, 0);
  }, [selectedSectionItems]);
  return {
    sectionItems: selectedSectionItems,
    totalAnswered: totalAnswered,
    totalQuestions: totalQuestions,
    selectQuestion: selectQuestion,
    toggleSection: toggleSection,
    isCollapsible: hasCollapseEffect
  };
};